<script>
import brandDevicePage from '~/pages/capinhas-para-celular/_slug.vue'
export default brandDevicePage
</script>
